import React from 'react'
import { Create } from 'react-admin'
import { connect } from 'react-redux'
import UMBreadcrumbs from '../../components/UMBreadcrumbs'
import organisations from '../../api/resources/organisations'
import OrganisationForm from './form'

const OrganisationCreate = ({ defaultPartner, permissions, dispatch, ...props }) => {
  const formProps = { defaultPartner, permissions }
  return (
    <Create
      title={<UMBreadcrumbs resourceName={organisations.getName()} currentLabel="Create organisation" />}
      undoable={false}
      {...props}
    >
      <OrganisationForm {...formProps} />
    </Create>
  )
}

export default connect(state => {})(OrganisationCreate)
